(function() {
    window.c24DomReady(function () {
        const authorImage = document.querySelector('.c24-author-image-wrapper.mod1');

        if (!authorImage) return;

        authorImage.addEventListener('click', function() {
            const rect = this.getBoundingClientRect();
            const centerX = rect.left + rect.width / 2;
            const centerY = rect.top + rect.height / 2;

            // Create 5-20 cats
            const numCats = 5 + Math.floor(Math.random() * 15);

            for (let i = 0; i < numCats; i++) {
                createCat(centerX, centerY);
            }
        });

        function createCat(x, y) {
            const cat = document.createElement('div');
            cat.className = 'c24-flying-cat';
            cat.style.position = 'fixed';
            cat.style.left = `${x}px`;
            cat.style.top = `${y}px`;
            cat.style.zIndex = '9999';
            cat.style.pointerEvents = 'none';

            // Random cat appearance
            const catSize = 30 + Math.random() * 20;
            cat.style.width = `${catSize}px`;
            cat.style.height = `${catSize}px`;
            cat.style.backgroundImage = 'url("/versicherungen/images/authors/cat.svg?v=cat")';
            cat.style.backgroundSize = 'contain';
            cat.style.backgroundRepeat = 'no-repeat';
            cat.style.transform = `rotate(${Math.random() * 360}deg)`;
            cat.style.opacity = '0.9';

            document.body.appendChild(cat);

            // Random direction and speed
            const angle = Math.random() * Math.PI * 2;
            const distance = 100 + Math.random() * 150;
            const duration = 3000 + Math.random() * 1500;

            const targetX = x + Math.cos(angle) * distance;
            const targetY = y + Math.sin(angle) * distance;

            cat.animate([
                {
                    transform: `translate(0, 0) rotate(${Math.random() * 360}deg)`,
                    opacity: 0.9,
                },
                {
                    transform: `translate(${targetX - x}px, ${targetY - y}px) rotate(${Math.random() * 360 + 360}deg)`,
                    opacity: 0,
                },
            ], {
                duration: duration,
                easing: 'cubic-bezier(0.21, 0.98, 0.6, 0.99)',
            }).onfinish = function() {
                cat.remove();
            };
        }
    });
})();
